import CountryPageReducer from './CountryPageReducer';

export default from './CountryPageContainer';

export const CountryPageReducers = {
  CountryPageReducer,
};
